import WhatInBox from '../../../compsNa/WhatInBox';
import EfSpec from 'elem/ui/ef-spec';
import css from './index.module.scss';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('theProduct.WhatInBox');
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_NA = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_UK = ['uk'].includes(locale);
    const IS_AU = ['au'].includes(locale);
    const [active, setActive] = useState(0);
    const [tabs, setTabs] = useState<string[]>([]);
    const items: { img: string; title: string }[][] = [
        [
            {
                title: t('a_item1'),
                img: IS_AU
                    ? 'https://websiteoss.ecoflow.com/upload/image/1736925516607/1.png'
                    : IS_UK
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725015937853/r3_uk.png'
                    : IS_EU
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725015852850/r3_eu.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724578776517/dd3.png',
            },
            { title: t('a_item2'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png' },
            { title: t('a_item4'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580660907/1.png' },
        ],
        [
            {
                title: t('b_item1'),
                img: IS_AU
                    ? 'https://websiteoss.ecoflow.com/upload/image/1736925847268/r3p1.png'
                    : IS_UK
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725015958676/r3_plus_uk.png'
                    : IS_EU
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725015884744/r3_plus_eu.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724578776333/dd2.png',
            },
            { title: t('b_item2'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png' },
            { title: t('b_item4'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png' },
            { title: t('b_item5'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580687382/2.png' },
        ],
        [
            {
                title: t('c_item1'),
                img: IS_AU
                    ? 'https://websiteoss.ecoflow.com/upload/image/1736926163840/r3m1.png'
                    : IS_UK
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725015976839/r3_max_uk.png'
                    : IS_EU
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725015903418/r3_max_eu.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724578027910/sl_r3m.png',
            },
            { title: t('c_item2'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png' },
            { title: t('c_item4'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png' },
            { title: t('c_item5'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580693542/3.png' },
        ],
    ];

    if (locale === 'au') {
        items[2].splice(2, 0, {
            title: t('c_item3'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
        });
        items.push([
            { title: t('d_item1'), img: 'https://websiteoss.ecoflow.com/upload/image/1736926593158/r3mp.png' },
            { title: t('d_item2'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png' },
            { title: t('d_item3'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png' },
            { title: t('d_item4'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png' },
            { title: t('d_item5'), img: 'https://websiteoss.ecoflow.com/upload/image/1724580693542/3.png' },
        ]);
    }

    useEffect(() => {
        if (['au'].includes(locale)) {
            setTabs([t('a_tab'), t('b_tab'), t('c_tab'), t('d_tab')]);
        } else {
            setTabs([t('a_tab'), t('b_tab'), t('c_tab')]);
        }
    }, []);

    return (
        <div className={css.TheComp}>
            {IS_EU || IS_NA || IS_AU ? (
                <div className={`box-eu ${IS_AU ? 'box-au' : ''}`}>
                    <EfSpec className="spec-x" />
                    <p className="title">{t('title')}</p>
                    <ul className={`items items-${active + 1}`}>
                        {items[active].map((item, index) => (
                            <li
                                className={`item item-${index + 1} ${active === index ? 'active' : ''}`}
                                key={index}
                                style={{
                                    gridArea: `item-${index + 1}`,
                                }}
                            >
                                <div className="item-img">
                                    <img src={item.img} alt={item.title} width="100%" height="100%" loading="lazy" />
                                </div>
                                <p className="item-title">{item.title}</p>
                            </li>
                        ))}
                    </ul>
                    <ul className="tabs">
                        {tabs.map((item, index) => (
                            <li className={`tab${active === index ? ' active' : ''}`} key={index} onClick={() => setActive(index)}>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            ) : (
                <WhatInBox />
            )}
            <EfSpec className="spec-x" />
        </div>
    );
}
